var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 7.57125V17.4912C20 19.0112 19.86 20.0912 19.5 20.8612C19.5 20.8713 19.49 20.8913 19.48 20.9013C19.26 21.1813 18.97 21.3213 18.63 21.3213C18.1 21.3213 17.46 20.9713 16.77 20.2313C15.95 19.3513 14.69 19.4213 13.97 20.3813L12.96 21.7213C12.56 22.2613 12.03 22.5312 11.5 22.5312C10.97 22.5312 10.44 22.2613 10.04 21.7213L9.02002 20.3713C8.31002 19.4212 7.05999 19.3512 6.23999 20.2213L6.22998 20.2313C5.09998 21.4412 4.10002 21.6213 3.52002 20.9013C3.51002 20.8913 3.5 20.8713 3.5 20.8612C3.14 20.0912 3 19.0112 3 17.4912V7.57125C3 6.05125 3.14 4.97125 3.5 4.20125C3.5 4.19125 3.50002 4.18125 3.52002 4.17125C4.09002 3.44125 5.09998 3.62125 6.22998 4.83125L6.23999 4.84125C7.05999 5.71125 8.31002 5.64125 9.02002 4.69125L10.04 3.34125C10.44 2.80125 10.97 2.53125 11.5 2.53125C12.03 2.53125 12.56 2.80125 12.96 3.34125L13.97 4.68125C14.69 5.64125 15.95 5.71125 16.77 4.83125C17.46 4.09125 18.1 3.74125 18.63 3.74125C18.97 3.74125 19.26 3.89125 19.48 4.17125C19.5 4.18125 19.5 4.19125 19.5 4.20125C19.86 4.97125 20 6.05125 20 7.57125Z",
    fill: "#FF5B00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.5312H8C7.59 11.5312 7.25 11.1912 7.25 10.7812C7.25 10.3713 7.59 10.0312 8 10.0312H16C16.41 10.0312 16.75 10.3713 16.75 10.7812C16.75 11.1912 16.41 11.5312 16 11.5312Z",
    fill: "#FF5B00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.0312H8C7.59 15.0312 7.25 14.6912 7.25 14.2812C7.25 13.8713 7.59 13.5312 8 13.5312H14C14.41 13.5312 14.75 13.8713 14.75 14.2812C14.75 14.6912 14.41 15.0312 14 15.0312Z",
    fill: "#FF5B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon1);
export default __webpack_public_path__ + "static/media/feature-icon-1.c4accc483832beb92304cbb7ea649462.svg";
export { ForwardRef as ReactComponent };